export type CustomError = {
  message?: string;
  statusCode?: number;
};

export const isCustomErrorCheck = (error: unknown): error is CustomError =>
  typeof error === "object" &&
  error !== null &&
  (("message" in error && typeof error.message === "string") ||
    ("statusCode" in error && typeof error.statusCode === "number"));
